import React from 'react';
import LogoImage from '../../assets/img/oops.png';

class Error extends React.Component{
  render(){
    return(
      <img src={LogoImage} alt="Logo" className="error-image"/>
    )
  }
}

export default Error;


// WEBPACK FOOTER //
// ./src/app/components/Error.jsx